import { LexmeaApiClient } from "~/api/apiClient";
import type { ILegalTextTier } from "~/models/ILegalTextTier";

export class LegalTextTierClient extends LexmeaApiClient {
  fetchAllTiers = () => {
    return this.get<ILegalTextTier[]>("api/legalTextTier");
  };

  fetchTierById = (id: number) => {
    return this.get<ILegalTextTier>(`api/legalTextTier/${id}`);
  };
}
